import { getCrossCalendarDefsForDest } from '@/lib/cross-calendar-pages';
import { getAlternateEvergreenLanguages } from '@/lib/slug-evergreen';
import { getTemplateStr } from '@/lib/i18n';
import type { CountryCode } from '@/lib/types';

interface CrossCalendarPillLinksProps {
  slugPrefix: string;
  countryCode: CountryCode;
  displayName: string;
  lang: string;
  linkTemplateKey: string;
}

export function CrossCalendarPillLinks({ slugPrefix, countryCode, displayName, lang, linkTemplateKey }: CrossCalendarPillLinksProps) {
  const crossDefs = getCrossCalendarDefsForDest(slugPrefix).slice(0, 6);
  if (crossDefs.length === 0) return null;

  const crossLinks = crossDefs.map(cd => {
    const entityId = `cross-calendar:${cd.originCode.toLowerCase()}:${countryCode.toLowerCase()}`;
    const alts = getAlternateEvergreenLanguages(entityId);
    const resolvedSlug = alts[lang] ?? alts['en'] ?? cd.slug;
    return { ...cd, resolvedSlug };
  });

  return (
    <div className="mb-8 border-t border-border-subtle pt-6">
      <h2 className="font-heading text-lg font-bold text-text-primary md:text-xl">
        {getTemplateStr('seo.cm.plan_trip_heading', lang, { destination: displayName })}
      </h2>
      <div className="mt-3 flex flex-wrap gap-2">
        {crossLinks.map(cd => (
          <a
            key={cd.resolvedSlug}
            href={`/${cd.resolvedSlug}`}
            className="rounded-full border border-border-subtle bg-surface-card px-3 py-1.5 text-xs font-medium text-accent-primary hover:bg-accent-primary/5"
          >
            {getTemplateStr(linkTemplateKey, lang, { flag: cd.originFlag, origin: cd.originName, destination: displayName })}
          </a>
        ))}
      </div>
    </div>
  );
}
